import React from 'react';

import { useSplitPane } from '../hooks/useSplitPane';

interface Props {
    left: React.ReactNode;
    right: React.ReactNode;
}

export default function SplitPane({ left, right }: Props): JSX.Element {
    const { leftWidth, containerRef, startDrag } = useSplitPane();

    return (
        <div className="prostep-split-container" ref={containerRef}>
            <div className="prostep-left" style={{ width: leftWidth }}>
                {left}
            </div>
            <div
                className="prostep-resizer"
                role="separator"
                aria-orientation="vertical"
                onMouseDown={startDrag}
                onTouchStart={startDrag}
            />
            <div className="prostep-right">
                {right}
            </div>
        </div>
    );
}
